var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"spinner-container",class:[
  _vm.data.class,
  _vm.data.staticClass
]},[_vm._m(0)])}
var staticRenderFns = [function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"sk-spinner sk-spinner-double-bounce"},[_c('div',{staticClass:"sk-double-bounce1"}),_c('div',{staticClass:"sk-double-bounce2"})])}]

export { render, staticRenderFns }